module.exports = __webpack_public_path__ + "img/search-icon@2x.549b620f.png";